// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.mt-2 {
  margin-top: 16px;
}

mat-card {
  width: 100%;
}

.form-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.personal-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
}

mat-form-field {
  width: 100%;
}

.header-inputs {
  margin-bottom: 16px;
}

table {
  width: 100%;
  margin-top: 16px;
}

mat-card {
  margin-bottom: 16px;
}

.enabled {
  color: green;
  font-weight: bold;
}

.disabled {
  color: red;
  font-weight: bold;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

mat-spinner {
  color: orange;
  height: 15px;
  margin-top: 25px;
}

.no-results-message {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100px;
  color: red;
}

.no-results-message p {
  margin: 0;
}

#userTable {
  overflow-x: auto;
  width: 100%;
}

#accountsTable {
  overflow-x: auto;
  width: 100%;
}

#transactionsTable {
  overflow-x: auto;
  width: 100%;
}

#ordersTable {
  overflow-x: auto;
  width: 100%;
}

tr {
  cursor: pointer;
}

.selected-row {
  background-color: #ff9800;
}

.pagination-controls {
  margin-top: 20px;
  font-size: 12px;
  text-align: center;
}

.pagination-controls button {
  margin: 0 5px;
}

.order-item {
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.order-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.order-column {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 5px;
  overflow: hidden;
}

.order-header {
  font-weight: bold;
  margin-bottom: 5px;
  color: black;
  text-transform: uppercase;
  font-size: 11px;
  padding: 2px;
  background-color: #ececec;
}

.order-value {
  overflow-wrap: break-word;
  word-break: break-word;
  font-size: 11px;
}

.order-item:not(:last-child) {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.custom-style {
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.custom-style .material-icons {
  color: orange;
}

#transactionsTable td {
  font-size: 12px;
}

#transactionsTable .mat-column-info {
  max-width: 150px;
}

#transactionsTable table, #transactionsTable th, #transactionsTable td {
  cursor: default !important;
}

#ordersTable td {
  cursor: none;
}

.user-item {
  display: grid;
  /* Crea 4 columnas de igual tamaño (1fr = 1 fracción del espacio disponible) */
  grid-template-columns: repeat(4, 1fr);
  gap: 20px; /* Espacio entre filas y columnas */
  padding: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

/* Estilos para cada campo individual */
.user-field {
  display: flex;
  flex-direction: column; /* Pone el header arriba y el value abajo */
  gap: 4px; /* Pequeño espacio entre header y value */
}

/* Estilo para que el campo de "Programas" ocupe las 4 columnas */
.userdata-field.full-width {
  /* Comienza en la línea 1 de la columna y termina en la última (-1) */
  grid-column: 1/-1;
}

/* Estilos para las etiquetas (header) y valores (value) */
.user-header {
  font-size: 11px;
  font-weight: bold;
  color: black;
  text-transform: uppercase;
  background-color: #ececec;
}

.user-value {
  font-size: 11px;
  color: #111;
  word-break: break-all; /* Evita que textos largos rompan el layout */
}

.section-title {
  grid-column: 1/-1;
  margin-top: 18px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e0e0e0;
  font-size: 14px;
  font-weight: bold;
  color: black;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/consolidado-puntos-pedidos/consolidado-puntos-pedidos.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,YAAA;EACA,iBAAA;AAEF;;AACA;EACE,UAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;AAEF;;AACA;EACE,SAAA;AAEF;;AACA;EACE,gBAAA;EACA,WAAA;AAEF;;AACA;EACE,gBAAA;EACA,WAAA;AAEF;;AACA;EACE,gBAAA;EACA,WAAA;AAEF;;AACA;EACE,gBAAA;EACA,WAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;AAEF;;AACA;EACE,yBAAA;EACA,sBAAA;EACA,eAAA;AAEF;;AACA;EACE,6BAAA;EACA,oBAAA;EACA,mBAAA;AAEF;;AACA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AAAA;EACE,aAAA;AAGF;;AAAA;EACE,eAAA;AAGF;;AAAA;EACE,gBAAA;AAGF;;AAAA;EACE,0BAAA;AAGF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,aAAA;EACA,8EAAA;EACA,qCAAA;EACA,SAAA,EAAA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAGF;;AAAA,uCAAA;AACA;EACE,aAAA;EACA,sBAAA,EAAA,2CAAA;EACA,QAAA,EAAA,yCAAA;AAGF;;AAAA,iEAAA;AACA;EACE,qEAAA;EACA,iBAAA;AAGF;;AAAA,0DAAA;AACA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AAGF;;AAAA;EACE,eAAA;EACA,WAAA;EACA,qBAAA,EAAA,6CAAA;AAGF;;AAAA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EAEA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;AAEF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.mt-2 {\n  margin-top: 16px;\n}\n\nmat-card {\n  width: 100%;\n}\n\n.form-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.personal-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  width: 100%;\n}\n\nmat-form-field {\n  width: 100%;\n}\n\n.header-inputs {\n  margin-bottom: 16px;\n}\n\ntable {\n  width: 100%;\n  margin-top: 16px;\n}\n\nmat-card {\n  margin-bottom: 16px;\n}\n\n.enabled {\n  color: green;\n  font-weight: bold;\n}\n\n.disabled {\n  color: red;\n  font-weight: bold;\n}\n\n.spinner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nmat-spinner {\n  color: orange;\n  height: 15px;\n  margin-top: 25px;\n}\n\n.no-results-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  height: 100px;\n  color: red;\n}\n\n.no-results-message p {\n  margin: 0;\n}\n\n#userTable {\n  overflow-x: auto;\n  width: 100%;\n}\n\n#accountsTable {\n  overflow-x: auto;\n  width: 100%;\n}\n\n#transactionsTable {\n  overflow-x: auto;\n  width: 100%;\n}\n\n#ordersTable {\n  overflow-x: auto;\n  width: 100%;\n}\n\ntr {\n  cursor: pointer;\n}\n\n.selected-row {\n  background-color: #ff9800;\n}\n\n.pagination-controls {\n  margin-top: 20px;\n  font-size: 12px;\n  text-align: center;\n}\n\n.pagination-controls button {\n  margin: 0 5px;\n}\n\n.order-item {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  padding: 10px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.order-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n}\n\n.order-column {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  padding: 5px;\n  overflow: hidden;\n}\n\n.order-header {\n  font-weight: bold;\n  margin-bottom: 5px;\n  color: black;\n  text-transform: uppercase;\n  font-size: 11px;\n  padding: 2px;\n  background-color: #ececec;\n}\n\n.order-value {\n  overflow-wrap: break-word;\n  word-break: break-word;\n  font-size: 11px;\n}\n\n.order-item:not(:last-child) {\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n\n.custom-style {\n  font-size: 12px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n}\n.custom-style .material-icons {\n  color: orange;\n}\n\n#transactionsTable td {\n  font-size: 12px;\n}\n\n#transactionsTable .mat-column-info{\n  max-width: 150px;\n}\n\n#transactionsTable table, #transactionsTable th, #transactionsTable td {\n  cursor: default !important;\n}\n\n#ordersTable td {\n  cursor: none;\n}\n\n.user-item {\n  display: grid;\n  /* Crea 4 columnas de igual tamaño (1fr = 1 fracción del espacio disponible) */\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px; /* Espacio entre filas y columnas */\n  padding: 16px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n\n/* Estilos para cada campo individual */\n.user-field {\n  display: flex;\n  flex-direction: column; /* Pone el header arriba y el value abajo */\n  gap: 4px; /* Pequeño espacio entre header y value */\n}\n\n/* Estilo para que el campo de \"Programas\" ocupe las 4 columnas */\n.userdata-field.full-width {\n  /* Comienza en la línea 1 de la columna y termina en la última (-1) */\n  grid-column: 1 / -1; \n}\n\n/* Estilos para las etiquetas (header) y valores (value) */\n.user-header {\n  font-size: 11px;\n  font-weight: bold;\n  color: black;\n  text-transform: uppercase;\n  background-color: #ececec;\n}\n\n.user-value {\n  font-size: 11px;\n  color: #111;\n  word-break: break-all; /* Evita que textos largos rompan el layout */\n}\n\n.section-title {\n  grid-column: 1 / -1;  \n  margin-top: 18px; \n  padding-bottom: 8px;\n  border-bottom: 2px solid #e0e0e0;\n  \n  font-size: 14px;\n  font-weight: bold;\n  color: black;\n  text-transform: uppercase;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
